import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DownloadIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M8.5 4a6 6 0 0 1 6.3 4.3c0 .4.5.7 1 .7h1.7a3.5 3.5 0 0 1 2 6.4 1 1 0 0 0 1 1.7 5.5 5.5 0 0 0-3-10.1h-1a8 8 0 1 0-13.2 8.6 1 1 0 1 0 1.4-1.4A6 6 0 0 1 8.5 4Z" />
      <path d="M8.7 16.3a1 1 0 0 0-1.4 1.4l4 4a1 1 0 0 0 1 .2 1 1 0 0 0 .4-.2l4-4a1 1 0 0 0-1.4-1.4L13 18.6V12a1 1 0 1 0-2 0v6.6l-2.3-2.3Z" />
    </Icon>
  )
);
export default DownloadIcon;
